import { Capacitor } from "@capacitor/core";

export function isNativeApp(): boolean {
  return Capacitor.isNativePlatform();
}

export function canUseGoogleMeasurement(): boolean {
  return typeof window !== "undefined" && !isNativeApp();
}

/** Native platform is fixed for the lifetime of a WebView. */
export function subscribeToNativePlatform() {
  return () => {};
}
